<template>
  <section class="poll-competition">
    <!-- label -->
    <SectionLabel text="網軍大比拚"/>

    <!-- intro -->
    <div class="poll-competition__intro">
      <span class="poll-competition__intro-text">空戰開打：社群戰場上，誰的粉絲力堅強，就可搶下網路聲量的主導權。</span>
    </div>

    <!-- popularity -->
    <Popularity class="poll-competition__popularity"/>

    <!-- source -->
    <div class="poll-competition__source">
      <span class="poll-competition__source-text">彙整 CrowdTangle 2019/8/1-10/31 資料。</span>
      <span class="poll-competition__source-text">粉絲數最後更新時間 2019/11/15</span>
    </div>
  </section>
</template>

<script>
import SectionLabel from '@/components/SectionLabel'
import Popularity from '@/components/Popularity'

export default {
  name: 'PollCompetition',
  components: {
    SectionLabel,
    Popularity
  }
}
</script>

<style lang="scss">
.poll-competition {
  position: relative;
  width: 100%;
  // min-height: 100vh;
  background: #f5c6b8;
  overflow: hidden;

  &:before {
    content: "";
    display: block;
    position: absolute;
    top: -290px;
    left: 0;
    width: 100%;
    height: 400px;
    background: #7e93ce;
    transform: skewY(-18deg);
    @include rwd($RWD_TABLET_SMALL) {
      transform: skewY(-10deg);
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      top: -600px;
      height: 800px;
    }
  }

  .section-label {
    margin-top: 55px;
    @include rwd($RWD_DESKTOP_WIDE) {
      margin-top: 140px;
    }
  }

  &__intro {
    position: relative;
    margin: 36px 20px;
    text-align: left;
    @include rwd($RWD_TABLET_SMALL) {
      max-width: 430px;
      margin: 36px auto;
    }
    @include rwd($RWD_TABLET) {
      max-width: 470px;
    }
    @include rwd($RWD_DESKTOP) {
      max-width: 640px;
    }
    @include rwd($RWD_DESKTOP_WIDE) {
      margin: 50px auto;
    }

    &-text {
      font-size: 0.875em;
      font-weight: 700;
      line-height: 1.714em;
      letter-spacing: 0.1em;
      @include rwd($RWD_TABLET_SMALL) {
        font-size: 1.125em;
        line-height: 1.667em;
      }
      @include rwd($RWD_DESKTOP) {
        line-height: 2em;
      }
    }
  }

  &__popularity {
    width: 100%;
    max-width: 1360px;
    margin: 0 auto;
  }

  &__source {
    position: relative;
    margin: 36px 20px 0 36px;
    text-align: left;
    @include rwd($RWD_TABLET_SMALL) {
      max-width: 455px;
      margin: 36px auto 0 auto;
    }
    @include rwd($RWD_TABLET) {
      max-width: none;
      text-align: center;
    }

    &-text {
      font-size: 0.75em;
      font-weight: 500;
      line-height: 2em;
      letter-spacing: 0.1em;
      @include rwd($RWD_TABLET_SMALL) {
        font-size: 0.875em;
        line-height: 2.143em;
      }
    }
  }
}
</style>
